import type { GameJackpot } from '../../../stores/game/types';

/**
 * The tile's `data-jackpot-coins` value — the coins whose Crown Jackpot this game contributes to,
 * space separated (`"GC SC"`), or `undefined` when it contributes to none.
 *
 * This is the CSS hook the badge's visibility rules match with `~=`. It exists because CSS cannot
 * compare two attribute values: there is no selector that asks "is this tile's jackpot id the one
 * `<body>` says is live". The coin is an enum with two values, so it CAN be written as static rules —
 * which is why player-backend sends `coinType` next to each jackpot id rather than the id alone.
 *
 * `undefined` rather than `''` so React omits the attribute entirely; an empty attribute would still
 * match `[data-jackpot-coins]` if anyone ever wrote that selector.
 */
export const jackpotCoinsAttr = (jackpots?: GameJackpot[]): string | undefined => {
  if (!jackpots?.length) {
    return undefined;
  }

  // Deduped: a game enrolled in two groups on the same coin must not repeat it.
  return [...new Set(jackpots.map((jackpot) => jackpot.coinType))].join(' ');
};
